"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whiteDataLabelTypes = exports.BLACK_LABEL = exports.WHITE_LABEL = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
exports.WHITE_LABEL = {
    color: "#ffffff",
    textShadow: "0 0 1px #000000",
};
exports.BLACK_LABEL = {
    color: "var(--gd-palette-complementary-9, #000000)",
    textShadow: "none",
};
// types with label inside sections have white labels
exports.whiteDataLabelTypes = [
    sdk_ui_1.VisualizationTypes.PIE,
    sdk_ui_1.VisualizationTypes.DONUT,
    sdk_ui_1.VisualizationTypes.TREEMAP,
    sdk_ui_1.VisualizationTypes.BUBBLE,
];
//# sourceMappingURL=label.js.map